import styles from './styles.module.scss';

import React from 'react';

import cn from 'classnames';

const Link = ({ className, children, blue = false, ...props }) => (
  <a className={cn(styles.a, blue && styles.link_blue, className)} {...props}>
    {children}
  </a>
);

export default Link;
